import * as clients from 'src/api/clients'
import router from 'src/router'
import {
  GET_CLIENT,
  SET_LOADED_CLIENT,
  GET_TOTAL_MONEY
} from 'src/store/mutation-types'

const getClient = ({commit, dispatch}, configs = {}) => {
  dispatch('toggleLoadding', true, {root: true})
  clients.getClient(configs).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_CLIENT, response.data)
      commit(SET_LOADED_CLIENT, response.data)
    } else if (response.code === 404) {
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        type: 'warning'
      }, {root: true})
      dispatch('toggleLoadding', false, {root: true})
      router.push({name: 'client'})
    } else {
      dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const cacheClient = ({commit}, data) => {
  commit(GET_CLIENT, data)
}

const getTotalMoney = ({commit, dispatch}, configs = {}) => {
  dispatch('toggleLoadding', true, {root: true})
  clients.getTotalMoney(configs).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_TOTAL_MONEY, response.data.total_money)
    } else if (response.code === 404) {
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        type: 'warning'
      }, {root: true})
      dispatch('toggleLoadding', false, {root: true})
      router.push({name: 'client'})
    } else {
      dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const exportExcel = ({commit, dispatch}, configs = {}) => {
  dispatch('toggleLoadding', true, {root: true})
  clients.exportExcel(configs).then(response => {
    if (response.code === 200) {
      dispatch('showNotify', {
        title: 'Thành công',
        body: 'Xuất excel thành công'
      }, {root: true})
      window.location.href = response.full
      dispatch('toggleLoadding', false, {root: true})
    } else if (response.code === 404) {
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        type: 'warning'
      }, {root: true})
      dispatch('toggleLoadding', false, {root: true})
      router.push({name: 'client'})
    } else {
      dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setClient = ({commit}, client) => {
  commit(GET_CLIENT, client)
}

export default {
  getClient,
  cacheClient,
  getTotalMoney,
  exportExcel,
  setClient
}



// WEBPACK FOOTER //
// ./src/components/client/store/actions.js